module.exports = __webpack_public_path__ + "img/ico-check.ec831730.svg";